import React from 'react'
import { ButtonBase } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import XIcon from '@src/icons/XIcon'

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'table',
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.text.primary,
    background: theme.palette.common.white,
    padding: theme.spacing(2),
    borderRadius: '3px',
    border: `1px solid ${theme.palette.grey[400]}`,
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(1, 1.5),
    },
    [theme.breakpoints.up('xl')]: {
      position: 'relative',
      paddingRight: theme.spacing(4),
    },
  },
  closeBtn: {
    marginLeft: theme.spacing(2),
    marginRight: '0 !important',
    [theme.breakpoints.up('xl')]: {
      position: 'absolute',
      top: theme.spacing(1.75),
      right: theme.spacing(0.75),
      marginLeft: 0,
      minWidth: 'auto',
      padding: theme.spacing(0.5),
    },
  },
  alignmentWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.up('xl')]: {
      paddingRight: theme.spacing(1.5),
    },
  },
}))

interface SelectionChipProps {
  label: string | React.ReactNode
  onDelete: () => void
  dataTestId?: string
  ariaLabel: string
}

const SelectionChipSrpRedesign: React.FC<SelectionChipProps> = ({
  label,
  onDelete,
  dataTestId,
  ariaLabel,
}) => {
  const { classes } = useStyles()
  const inspectedLabel =
    typeof label === 'string' ? <span>{label}</span> : label
  return (
    <div className={classes.root} data-testid={dataTestId}>
      <div className={classes.alignmentWrapper}>
        <span>{inspectedLabel}</span>
        <ButtonBase
          aria-label={ariaLabel}
          className={classes.closeBtn}
          onClick={onDelete}
        >
          <XIcon color="primary" fontSize="small" />
        </ButtonBase>
      </div>
    </div>
  )
}

export default SelectionChipSrpRedesign
